<div class="card m-3"> 
    <div class="card-body">
<form (ngSubmit)="saveManufacturer()">
    <label>Name:</label>
    <input type="text" [(ngModel)]="newManufacturer.name" name="Name" required />
  
    <label>Country:</label>
    <input type="text" [(ngModel)]="newManufacturer.country" name="Country" required />
  
    <button type="submit">Add Manufacturer</button>
  </form>
  </div>
  </div>
  